import React from 'react'

function SelfAssessmentTour({ setHomeScreenWalkThroughPopup, setStepsEnabled }) {
    return (
        <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucess innerContainerFlex">
                <div className="imageContainer">
                    <img src="/gif/activity_guide.gif" alt="" />
                </div>
                <div className="rightContainer">
                    <div className="studentLogos leftMargin">
                        <div></div>
                        <div>
                            <img
                                src="/StudentImg/BreathSchoolLogo.png"
                                alt="icon"
                                width={"30px"}
                            ></img>
                        </div>
                    </div>
                    <div className=" overallMarginHead" style={{ position: "relative" }}>
                        <h4 className="textColor1"> Welcome to Self Assessment Section</h4>
                        <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
                            document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
                        }} />
                    </div>

                    <div className=" overallMargin">
                        <p className="textColor2">
                            1. Create and Take Self-Assessments Anywhere Anytime.
                        </p>
                        <hr></hr>
                        <p className="textColor2" >
                            2. Identifies Personal Learning Gaps and Encourages Independent Learning.
                        </p>
                        <hr></hr>
                        <p className="textColor2" >
                            3. Instant Results and Feedback. Boosts Confidence in Knowledge.
                        </p>
                        <hr></hr>
                        <p className="textColor2" >
                            4. Promotes Self-Reflection on Progress. Helps Set Personal Goals.
                        </p>
                        <hr></hr>
                        <p className="textColor2" id="last-paragraph">
                            5. Strengthens Retention Through Practice. Promotes Continuous Improvement.
                        </p>
                        <hr></hr>
                    </div>

                    <div className="buttonsContainer">
                        <button
                            className="rightBtn"
                            onClick={() => {
                                setHomeScreenWalkThroughPopup(false);
                                setStepsEnabled(true);
                            }}
                        >
                            Take me to the product tour
                        </button>
                        <button
                            className="leftBtn"
                            onClick={() => setHomeScreenWalkThroughPopup(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelfAssessmentTour